import queryString from 'query-string';
import { getCampaignType, campaignId } from 'pages/MyAccount/utils/campaign';
import env from 'pages/MyAccount/utils/env';
import { getCartVariants, flattenProducts } from '@fff-web/fff-cart';
import request from './request';

export function requestCartData() {
  const type = getCampaignType();
  let requestUrl = `${env.aceApi}api/1/carts/campaigns?type=${type}`;
  if (campaignId !== null) {
    requestUrl += `&campaignId=${campaignId}`;
  }
  return request(requestUrl);
}

export async function getCartData() {
  const {
    products: productsWithVariants,
    cartDetails,
  } = await requestCartData();
  const { products, variants } = flattenProducts(productsWithVariants);
  return { products, variants, cartDetails };
}

export async function fetchCartData() {
  const {
    products: productsWithVariants,
    cartDetails,
    cartId,
  } = await requestCartData();
  const { products, variants } = flattenProducts(productsWithVariants);
  const cartVariants = getCartVariants(cartDetails, variants, products);
  return { cartDetails, cartVariants, cartId };
}

export function updateCart(variantId, queryParams) {
  const params = campaignId
    ? {
        ...queryParams,
        campaignId,
      }
    : queryParams;
  const requestUrl = `${env.aceApi}api/1/carts/variants/${variantId}${
    params ? `?${queryString.stringify(params)}` : ''
  }`;
  return request(requestUrl, 'POST');
}

export function getPurchasedVariants(campaignIdNumber, campaignType) {
  const requestUrl = `${env.aceApi}api/1/carts/campaigns/${campaignIdNumber}/purchases?type=${campaignType}`;
  return request(requestUrl);
}
